module.exports = __webpack_public_path__ + "img/call.391e6005.png";